import React, { useRef } from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'

import { FullFeedBodyHeader, LeftBox, MiniBodyHeader, RightBox } from '../..'
import { useContainerDimensions } from '../../../hooks/useContainerDimensions'
import { DepositBodyBaseProps } from '../../../types/DirectDeposit'
import { Confetti } from '../Confetti'

const SHARED_STYLES = {
  card: {
    miniWidget: { gap: 8, p: '12px 16px', mt: 0 },
    insightFeed: { gap: 12, p: '0px 16px 16px', mt: 22 },
  },
}

const MINI_WIDGET = 'miniWidget'
const INSIGHT_FEED = 'insightFeed'

export const DirectDeposit: React.FC<DepositBodyBaseProps> = ({
  account,
  animation,
  leftLowerText,
  leftUpperText,
  isComplete,
  isMini,
  headerString,
  rightLowerText,
  rightUpperText,
}) => {
  const feedType = isMini ? MINI_WIDGET : INSIGHT_FEED

  const containerRef = useRef<HTMLDivElement>(null)
  const { height, width } = useContainerDimensions(containerRef)

  return (
    <Box
      alignItems="center"
      display="flex"
      justifyContent="center"
      ref={containerRef}
      sx={{ bgcolor: 'grey.200', p: 16 }}
      width="100%"
    >
      <Confetti height={height} shouldRun={animation.shouldRun} width={width} />
      <Card
        elevation={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          overflow: 'visible',
          minHeight: 120,
          width: '100%',
          ...SHARED_STYLES.card[feedType],
        }}
      >
        {feedType === INSIGHT_FEED && (
          <FullFeedBodyHeader account={account} headerString={headerString} />
        )}
        {feedType === MINI_WIDGET && (
          <MiniBodyHeader account={account} headerString={headerString} />
        )}
        <Stack direction="row" gap={12} height={58} width="100%">
          <LeftBox leftLowerText={leftLowerText} leftUpperText={leftUpperText} />
          <RightBox
            isComplete={isComplete}
            rightLowerText={rightLowerText}
            rightUpperText={rightUpperText}
          />
        </Stack>
      </Card>
    </Box>
  )
}
